import React from "react";
import PropTypes from "prop-types";
import {
  Table as ChakraTable,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Box,
} from "@chakra-ui/react";

const Table = ({ headers, data, renderRow }) => {
  return (
    <TableContainer boxShadow="md">
      <ChakraTable variant="simple">
        <Thead>
          <Tr>
            {headers.map((header, index) => (
              <Th key={index} p={5} fontSize="sm">
                <Box textAlign="center"> {header}</Box>
              </Th>
            ))}
          </Tr>
        </Thead>
        <Tbody>
          {data.map((item, index) => (
            <Tr key={index}>{renderRow(item)}</Tr>
          ))}
        </Tbody>
      </ChakraTable>
    </TableContainer>
  );
};

Table.propTypes = {
  headers: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.array.isRequired,
  renderRow: PropTypes.func.isRequired,
};

export default Table;
